import React from 'react';

import { Button, ButtonProps, Typography } from '@mui/material';

export default function HeroCTAButton({ children, ...props }: ButtonProps) {
  return (
    <Button variant="contained" size="large" color="secondary" {...props}>
      <Typography variant="button">{children}</Typography>
    </Button>
  );
}
